import { z } from 'zod'

import { InventoryType } from '../constants/inventory'
import { GenderType } from '../constants/gender'
import { TicketTokenType } from '../constants/ticket'
import { dbEntitySchema } from './system'

export const ticketSchema = dbEntitySchema.extend({
  booking: z.string().optional(),
  admissionGroup: z.string().optional(),
  user: z.string().optional(),
  prospect: z.string().optional(),
  venue: z.string(),
  event: z.string().optional(),
  inventory: z.string().optional(),
  inventoryType: z.nativeEnum(InventoryType),
  date: z.date(),
  name: z.string().optional(),
  price: z.number().optional(),
  info: z.string().optional(),
  gender: z.nativeEnum(GenderType).optional(),
  checkedIn: z.boolean().optional(),
  checkedInTime: z.date().optional(),
  checkedInBy: z.string().optional(),
  cancelled: z.boolean().optional(),
  token: z.string().optional(),
  tokenType: z.nativeEnum(TicketTokenType).optional(),
  qrCode: z.string().optional(),
  eventbrite: z
    .object({
      barcode: z.string().optional(),
    })
    .optional(),
})

export const ticketListQuerySchema = z.object({
  bookingId: z.string().optional(),
  orderId: z.string().optional(),
  admissionGroupId: z.string().optional(),
  venueId: z.string().optional(),
  start: z.date().optional(),
  end: z.date().optional(),
})

export const ticketCreateSchema = z
  .object({
    bookingId: z.string().optional(),
    venueId: z.string(),
    inventoryId: z.string().optional(),
    date: z.date(),
    name: z.string(),
    price: z.number(),
    info: z.string().optional(),
    gender: z.nativeEnum(GenderType).optional(),
    admissionGroupId: z.string().optional(),
    userId: z.string().optional(),
    prospectId: z.string().optional(),
    eventId: z.string().optional(),
    eventbriteBarcode: z.string().optional(),
    checkInStart: z.date().optional(),
    checkInEnd: z.date().optional(),
    checkedIn: z.boolean().optional(),
    checkedInTime: z.date().optional(),
    checkedInBy: z.string().optional(),
    cancelled: z.boolean().optional(),
    token: z.string().optional(),
    tokenType: z.nativeEnum(TicketTokenType).optional(),
    qrCode: z.string().optional(),
    sort: z.number().optional(),
  })
  .refine((data) => Boolean(data.bookingId || data.admissionGroupId), {
    message: 'bookingId or admissionGroupId is required',
    path: ['bookingId'],
  })
